export const checkForActiveHunt = (setIsActiveHunt) => {
  const startedHunt = window.localStorage.getItem('sh.started');
  const completedHunt = window.localStorage.getItem('sh.completed');
  if (startedHunt && !completedHunt) {
    setIsActiveHunt(true);
  }
};
